import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import {
  handleCreateNewCannedResponse,
  handleDeleteCannedResponse,
  handleGetCannedResponseCategories,
  handleGetCannedResponsesByCategory,
} from './actions';
import { ICannedResponsesState } from './slice.interface';

const initialState: ICannedResponsesState = {
  data: null,
  isLoading: false,
  error: false,
  categories: null,
  categoriesIsLoading: false,
  categoriesError: false,
  selectedCategory: null,
  isDeleting: false,
};

export const cannedResponsesSlice = createSlice({
  name: 'canned-responses',
  initialState,
  reducers: {
    removeCannedResponses: (state: ICannedResponsesState) => {
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },

    removeSelectedCategory: (state: ICannedResponsesState) => {
      state.selectedCategory = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetCannedResponseCategories.pending, (state: ICannedResponsesState) => {
        state.categories = null;
        state.categoriesIsLoading = true;
        state.categoriesError = false;
        state.selectedCategory = null;
      })
      .addCase(handleGetCannedResponseCategories.rejected, (state: ICannedResponsesState) => {
        state.categoriesIsLoading = false;
        state.categoriesError = true;
      })
      .addCase(
        handleGetCannedResponseCategories.fulfilled,
        (state: ICannedResponsesState, action) => {
          state.categories = action.payload.data;
          state.categoriesIsLoading = false;
        },
      )
      .addCase(
        handleGetCannedResponsesByCategory.pending,
        (state: ICannedResponsesState, action) => {
          state.selectedCategory = action.meta.arg;
          state.data = null;
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(handleGetCannedResponsesByCategory.rejected, (state: ICannedResponsesState) => {
        state.isLoading = false;
        state.error = false;
      })
      .addCase(
        handleGetCannedResponsesByCategory.fulfilled,
        (state: ICannedResponsesState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
        },
      )
      .addCase(handleCreateNewCannedResponse.fulfilled, (state, action) => {
        eventBus.emit(EventType.ADMIN_CREATE_NEW_CANNED_RESPONSE_SUCCESS, action.meta.arg.comments);
      })
      .addCase(handleDeleteCannedResponse.pending, (state: ICannedResponsesState) => {
        state.isDeleting = true;
      })
      .addCase(handleDeleteCannedResponse.rejected, (state: ICannedResponsesState) => {
        state.isDeleting = false;
      })
      .addCase(handleDeleteCannedResponse.fulfilled, (state: ICannedResponsesState) => {
        eventBus.emit(EventType.ADMIN_DELETE_CANNED_RESPONSE_SUCCESS);
        state.isDeleting = false;
      });
  },
});

export const { removeCannedResponses, removeSelectedCategory } = cannedResponsesSlice.actions;

export default cannedResponsesSlice.reducer;
